import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { ErrorHandlingService } from '../error-handling/error-handling.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SpinnerService } from '../spinner';
import { HttpHeaderConstants } from '../http-header.constant';
import { catchError, finalize, retry } from 'rxjs/operators';
import { NetsuiteField } from '../../models/appcloud/netsuite/netsuite-field.model';

@Injectable({
    providedIn: 'root',
})
export class NetsuiteFieldService {
    readonly #http = inject(HttpClient);
    readonly #spinnerService = inject(SpinnerService);
    readonly #errorHandlingService = inject(ErrorHandlingService);

    private FIELDS_URL: string = environment.publicApiHost + '/appcloud/fields';

    getFieldsForEntity(
        connectionId?: number,
        entityId?: number,
        additionalHeaders: any = {}
    ): Observable<NetsuiteField[]> {
        this.#spinnerService.addProcess(
            'NetsuiteFieldsService.getFieldsForEntity.' + entityId,
            'Retrieving field information for selected entity...'
        );

        const customHttpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
            params: new HttpParams({}).append('includeComparators', true.toString()),
        };

        return this.#http
            .get<
                NetsuiteField[]
            >(this.FIELDS_URL + '/connection/' + connectionId + '/entity/' + entityId, customHttpOptions)
            .pipe(
                retry(0),
                catchError(error => {
                    this.#errorHandlingService.handleHttpError(
                        error,
                        false,
                        'An error occurred while retrieving field information for your selected entity. Please try again later.'
                    );
                    return of<NetsuiteField[]>();
                }),
                finalize(() =>
                    this.#spinnerService.completeProcess('NetsuiteFieldsService.getFieldsForEntity.' + entityId)
                )
            );
    }
}
